import type { ProcessActivityHeaderProps } from '@ksyos/design-system/dist/components/process-activity/process-activity-header';
import { DateTime } from '@ksyos/date-time';
import { cloneDeep, isArray, mergeWith } from 'lodash';
import type {
    CustomControlData,
    DefinedCustomControlData,
    IProcessActivity,
    IServiceActivity,
} from '@common/interfaces';
import { ProcessActivityStatus } from '@common/enums';
import { ProcessActivityExternalPerformerName } from '@common/enums/serviceWorkflow/processActivityExternalPerformerName';
import { getDisplayName } from '@common/utils/getDisplayName';

export function getCommonHeaderProps(
    hasElementToDisplay: boolean,
    serviceActivity: IServiceActivity,
    processActivity?: IProcessActivity
): ProcessActivityHeaderProps {
    return {
        date: processActivity?.performedDatetime,
        organizationName: processActivity?.performerOrganization?.name,
        practitionerName: getPractitionerName(processActivity),
        // an empty activity was not created by a user, so is not considered to have a status that is relevant to the user.
        status: hasElementToDisplay ? processActivity?.status : undefined,
        title: processActivity?.title ?? serviceActivity.label,
        titleBadge:
            processActivity?.lastModifiedDateTime && processActivity?.status !== ProcessActivityStatus.cancelled
                ? {
                      text: 'Bewerkt',
                      tooltipText: DateTime.from(processActivity.lastModifiedDateTime).format('DD-MM-YYYY [om] HH:mm'),
                  }
                : processActivity?.status === ProcessActivityStatus.draft
                  ? { text: 'Concept' }
                  : undefined,
    };
}

function getPractitionerName(processActivity?: IProcessActivity): string | undefined {
    if (processActivity?.externalPerformerName) {
        if (processActivity.externalPerformerName === ProcessActivityExternalPerformerName.caro) {
            return 'Ksyos Obesitas App';
        }

        return processActivity.externalPerformerName;
    }

    if (processActivity?.performerPractitioner) {
        return getDisplayName(processActivity.performerPractitioner);
    }
}

export function getMergedActivityData(
    prevActivityData: DefinedCustomControlData,
    currentActivityData: Partial<CustomControlData>
): DefinedCustomControlData {
    function changeArrayException(obj: DefinedCustomControlData, src: Partial<CustomControlData>) {
        if (isArray(obj)) {
            return src;
        }
    }

    return mergeWith(cloneDeep(prevActivityData), currentActivityData, changeArrayException);
}
